'use strict'

document.addEventListener("DOMContentLoaded", () => {
  /********************************
   * Common variables
   *******************************/
  const html = document.querySelector('html');
  const body = document.querySelector('body');

  /********************************
   * Video section
   *******************************/
  const sectionGroupVideo = document.querySelectorAll('.section-video');

  if (sectionGroupVideo.length) {

    function lazyLoadVideo(video) {
      const sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) return;

      sources.forEach(s => {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      });

      video.load();

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
        });
      }
    }

    function setPlayUI(btn, playing) {
      if (!btn) return;
      const iconPlay = btn.querySelector('.icon-play');
      const iconStop = btn.querySelector('.icon-stop');
      if (playing) {
        iconPlay?.classList.add('hidden');
        iconStop?.classList.remove('hidden');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        iconPlay?.classList.remove('hidden');
        iconStop?.classList.add('hidden');
        btn.setAttribute('aria-pressed', 'false');
      }
    }

    function wireClickDelegation(sectionEl) {
      sectionEl.addEventListener('click', ({target}) => {
        const btn = target.closest('.button-sounds, .button-play');
        if (!btn) return;

        const videoContainer = btn.closest('.video-container');
        if (!videoContainer) return;

        const video = videoContainer.querySelector('video');
        if (!video) return;

        if (video.querySelector('source[data-src]')) {
          lazyLoadVideo(video);
        }

        if (btn.classList.contains('button-sounds')) {
          video.muted = !video.muted;
          btn.classList.toggle('active', !video.muted);
          btn.setAttribute('aria-pressed', String(!video.muted));
        }

        if (btn.classList.contains('button-play')) {
          if (video.paused) {
            video.play().then(() => setPlayUI(btn, true)).catch(() => {
            });
          } else {
            video.pause();
            setPlayUI(btn, false);
          }
        }
      });
    }

    const videos = document.querySelectorAll('.js-lazy-video');

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            lazyLoadVideo(e.target);
            io.unobserve(e.target);
          }
        });
      }, {rootMargin: '200px'});

      videos.forEach(v => io.observe(v));
    } else {
      videos.forEach(v => lazyLoadVideo(v));
    }

    sectionGroupVideo.forEach(wireClickDelegation);

    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      document.querySelectorAll('.js-lazy-video[loop]').forEach(v => v.removeAttribute('loop'));
    }
  }

  /********************************
   * Video nav: Custom content
   *******************************/
  const sectionCustomContent = document.querySelectorAll('.section-custom-content');

  if (sectionCustomContent.length) {
    function lazyLoadVideo(video) {
      const sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) return;
      sources.forEach(s => {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      });
      video.load();
    }

    function setPlayUI(btn, playing) {
      if (!btn) return;
      const iconPlay = btn.querySelector('.icon-play');
      const iconStop = btn.querySelector('.icon-stop');
      if (playing) {
        iconPlay?.classList.add('hidden');
        iconStop?.classList.remove('hidden');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        iconPlay?.classList.remove('hidden');
        iconStop?.classList.add('hidden');
        btn.setAttribute('aria-pressed', 'false');
      }
    }

    function getSectionVideo(section) {
      const player = section.querySelector('.video-background .video__player[data-video-id]');
      if (!player) return null;
      const videoId = player.getAttribute('data-video-id');
      if (!videoId) return null;
      const video = document.getElementById(videoId);
      return video || null;
    }

    function syncPlayButtons(section, playing) {
      section.querySelectorAll('.video-navigation .button-play').forEach(btn => {
        setPlayUI(btn, playing);
      });
    }

    sectionCustomContent.forEach(section => {
      const videoNavigation = section.querySelector('.video-navigation');
      if (!videoNavigation) return;

      let video = getSectionVideo(section);
      if (video) {
        video.addEventListener('play', () => syncPlayButtons(section, true));
        video.addEventListener('pause', () => syncPlayButtons(section, false));
        video.addEventListener('ended', () => syncPlayButtons(section, false));
        syncPlayButtons(section, !video.paused);
      }

      let wired = !!video;

      videoNavigation.addEventListener('click', (e) => {
        const btn = e.target.closest('.button-sounds, .button-play');
        if (!btn || btn.disabled || !videoNavigation.contains(btn)) return;

        if (!wired) {
          video = getSectionVideo(section);
          if (video) {
            video.addEventListener('play', () => syncPlayButtons(section, true));
            video.addEventListener('pause', () => syncPlayButtons(section, false));
            video.addEventListener('ended', () => syncPlayButtons(section, false));
            syncPlayButtons(section, !video.paused);
            wired = true;
          }
        }
        if (!video) return;

        if (video.querySelector('source[data-src]')) {
          lazyLoadVideo(video);
        }

        if (btn.classList.contains('button-sounds')) {
          const willUnmute = video.muted;
          video.muted = !video.muted;
          btn.classList.toggle('active', !video.muted);
          btn.setAttribute('aria-pressed', String(!video.muted));

          if (willUnmute && video.paused) {
            const p = video.play();
            if (p?.catch) p.catch(() => {
            });
          }
          return;
        }

        if (btn.classList.contains('button-play')) {
          if (video.paused) {
            const p = video.play();
            if (p && typeof p.then === 'function') {
              p.then(() => setPlayUI(btn, true)).catch(() => {
              });
            } else {
              setPlayUI(btn, !video.paused);
            }
          } else {
            video.pause();
            setPlayUI(btn, false);
          }
        }
      });
    });

    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      document.querySelectorAll('.section-custom-content video[loop]').forEach(v => v.removeAttribute('loop'));
    }
  }

  /********************************
   * Countdown Timer
   *******************************/
  const MARKET_TIMEZONES = {
    us: "America/New_York",
    au: "Australia/Sydney",
    uk: "Europe/London",
    eu: "Europe/Stockholm",
    ca: "America/Toronto"
  };

  function initCountdownTimers() {
    const countdownBlocks = document.querySelectorAll('.countdown[data-countdown-date]');

    if (countdownBlocks.length === 0) {
      return;
    }

    function updateCountdown(block) {
      const dateString = block.getAttribute('data-countdown-date');
      if (!dateString) {
        block.style.display = 'none';
        return;
      }

      const market = document.body.dataset.market;
      const timezone = MARKET_TIMEZONES[market] || "UTC";
      
      let targetDate = new Date(dateString);
      let now = new Date();
      
      if (timezone && timezone !== "UTC") {
        const nowUTC = new Date();
        const formatter = new Intl.DateTimeFormat('sv-SE', {
          timeZone: timezone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        });
        
        const nowInShopTZ = formatter.format(nowUTC).replace(' ', 'T');
        now = new Date(nowInShopTZ);
        targetDate = new Date(dateString);
      }
      
      const diff = targetDate - now;

      if (diff <= 0) {
        block.style.display = 'none';
        return;
      }

      const totalHours = Math.floor(diff / (1000 * 60 * 60));
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      const daySpan = block.querySelector('.timer .day');
      const dayDot = block.querySelector('.timer .dot-day');
      const hrsSpan = block.querySelector('.timer .hrs');
      const hrsDot = block.querySelector('.timer .dot-hrs');
      const minSpan = block.querySelector('.timer .min');

      if (!daySpan || !hrsSpan || !minSpan) {
        return;
      }

      if (totalHours >= 24) {
        daySpan.textContent = `${days} ${days === 1 ? 'day' : 'days'}`;
        daySpan.style.display = '';
        if (dayDot) dayDot.style.display = 'none';
        hrsSpan.style.display = 'none';
        if (hrsDot) hrsDot.style.display = 'none';
        minSpan.style.display = 'none';
      } else {
        daySpan.style.display = 'none';
        if (dayDot) dayDot.style.display = 'none';
        hrsSpan.style.display = '';
        hrsSpan.textContent = `${hours} hrs`;
        if (hrsDot) hrsDot.style.display = '';
        minSpan.style.display = '';
        minSpan.textContent = `${minutes < 10 ? '0' : ''}${minutes} min`;
      }
    }

    countdownBlocks.forEach(block => {
      updateCountdown(block);
    });

    setInterval(() => {
      countdownBlocks.forEach(block => {
        updateCountdown(block);
      });
    }, 1000);
  }

  initCountdownTimers();

  document.addEventListener('theme:cart:loaded', function () {
    setTimeout(initCountdownTimers, 100);
  });

  document.addEventListener('theme:cart:open', function () {
    setTimeout(initCountdownTimers, 100);
  });

  /********************************
   * Countdown Product Variant Handler
   *******************************/
  function initCountdownProductVariantHandler() {
    const productSingle = document.querySelector('.product-single');

    if (productSingle) {
      const countdownProduct = productSingle.querySelector('.countdown-product[data-countdown-variants]');
      if (!countdownProduct) {
        return;
      }

      const variantsDataScript = productSingle.querySelector('[data-countdown-variants-data]');
      if (!variantsDataScript) {
        return;
      }

      let variantsData;
      try {
        let jsonText = variantsDataScript.textContent.trim();
        jsonText = jsonText.replace(/[\r\n]+/g, ' ').replace(/\s+/g, ' ');
        variantsData = JSON.parse(jsonText);
      } catch (e) {
        console.error('[COUNTDOWN] Error parsing variants data:', e);
        console.error('[COUNTDOWN] JSON text:', variantsDataScript.textContent);
        return;
      }

      function checkVariantPreorder(variant, preorderTags, hasPreorderTag) {
        if (variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue') {
          return true;
        }

        if (hasPreorderTag && variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue') {
          return true;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        for (let tag of preorderTags) {
          const parts = tag.split(':');
          if (parts.length >= 4 && parts[2] === 'preorder-date') {
            const tagSku = parts[1].toLowerCase();
            const variantSku = (variant.sku || '').toLowerCase();

            if (tagSku === '*' || tagSku === variantSku) {
              const dateString = parts[3];
              const dateParts = dateString.split('-');

              if (dateParts.length === 3) {
                const month = parseInt(dateParts[0], 10);
                const day = parseInt(dateParts[1], 10);
                const year = parseInt(dateParts[2], 10);

                if (!isNaN(month) && !isNaN(day) && !isNaN(year) && month > 0 && month <= 12 && day > 0 && day <= 31) {
                  const preorderDate = new Date(year, month - 1, day);
                  preorderDate.setHours(0, 0, 0, 0);

                  if (preorderDate > today) {
                    return true;
                  }
                }
              }
            }
          }
        }

        return false;
      }

      function shouldShowCountdown(variantId) {
        const variant = variantsData.variants.find(v => v.id === variantId);
        if (!variant) {
          return false;
        }

        if (!variant.has_discount) {
          return false;
        }

        const isPreorder = checkVariantPreorder(variant, variantsData.preorder_tags || [], variantsData.has_preorder_tag || false);

        if (variant.available || isPreorder) {
          return true;
        }

        return false;
      }

      function updateCountdownVisibility(variantId) {
        if (shouldShowCountdown(variantId)) {
          countdownProduct.style.display = '';
        } else {
          countdownProduct.style.display = 'none';
        }
      }

      function getCurrentVariantId() {
        const productForm = document.querySelector('[data-product-form]');
        if (!productForm) return null;

        const variantInput = productForm.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) return null;

        return parseInt(variantInput.value, 10);
      }

      function checkAndUpdateCountdown() {
        const variantId = getCurrentVariantId();
        if (variantId) {
          updateCountdownVisibility(variantId);
        }
      }

      productSingle.addEventListener('click', function ({target}) {
        if (target.closest('.swatch__button')) {
          setTimeout(checkAndUpdateCountdown, 300);
        }
      });

      const productForm = document.querySelector('[data-product-form]');
      if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput) {
          const currentVariantId = parseInt(variantInput.value, 10);
          if (currentVariantId) {
            updateCountdownVisibility(currentVariantId);
          }

          const observer = new MutationObserver(function () {
            setTimeout(checkAndUpdateCountdown, 100);
          });

          observer.observe(variantInput, {
            attributes: true,
            attributeFilter: ['value']
          });
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initCountdownProductVariantHandler, 500);
    });
  } else {
    setTimeout(initCountdownProductVariantHandler, 500);
  }
});

/********************************
 * Pre-order text formatting functions
 *******************************/
function formatPreorderDate(dateString) {
  if (!dateString) return '';

  const dateParts = dateString.split('-');
  if (dateParts.length !== 3) return '';

  const day = parseInt(dateParts[0], 10);   // DD
  const month = parseInt(dateParts[1], 10); // MM
  const year = parseInt(dateParts[2], 10);  // YYYY

  if (isNaN(month) || isNaN(day) || isNaN(year)) return '';

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const monthName = monthNames[month - 1];
  if (!monthName) return '';

  let daySuffix = 'th';
  if (day === 11 || day === 12 || day === 13) {
    daySuffix = 'th';
  } else {
    const dayModulo = day % 10;
    if (dayModulo === 1) daySuffix = 'st';
    else if (dayModulo === 2) daySuffix = 'nd';
    else if (dayModulo === 3) daySuffix = 'rd';
  }

  return `${monthName} ${day}${daySuffix}`;
}

/********************************
 * Upsell Product Swatches
 *******************************/
(function() {
  const market = document.body && document.body.getAttribute('data-market');

  function handleSwatchClick(e) {
    const swatch = e.target.closest('.swatch__button--product');
    if (!swatch) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    let swatchLabel = swatch.querySelector('.swatch__label');
    if (!swatchLabel) {
      return;
    }

    let variantId = swatchLabel.dataset.swatchVariant * 1;
    let variantImg = swatchLabel.dataset.swatchImage;
    let variantAvailable = swatchLabel.dataset.variantAvailable === 'true';
    let variantInventoryQtyAttr = swatchLabel.dataset.variantInventoryQty;
    let variantInventoryQty = variantInventoryQtyAttr !== undefined && variantInventoryQtyAttr !== 'null' ? parseInt(variantInventoryQtyAttr) : null;
    let variantInventoryPolicy = swatchLabel.dataset.variantInventoryPolicy || 'deny';
    let isPreorder = swatchLabel.dataset.isPreorder === 'true';
    let selectedColor = swatchLabel.dataset.swatch;
    let productBlock = swatch.closest('.product-upsell-item');

    if (!productBlock) {
      return;
    }

    const hasPreorderTag = productBlock.dataset.productPreorderTag === 'true';

    const selectedColorText = productBlock.querySelector('[data-selected-color-text]');
    const selectedColorValue = productBlock.querySelector('[data-selected-color-value]');
    if (selectedColorText && selectedColorValue && selectedColor) {
      const swatchContainer = productBlock.querySelector('[data-swatch-label]');
      const colorLabel = swatchContainer ? swatchContainer.dataset.swatchLabel : 'Color';
      selectedColorValue.textContent = selectedColor;
    }

    const addButton = productBlock.querySelector('[data-add-to-cart]');
    const addButtonText = addButton ? addButton.querySelector('.product-upsell-item__btn-text') : null;
    const form = productBlock.querySelector('.product-upsell-item__form');

    const variantSku = (swatchLabel.dataset.swatchVariants || '').toLowerCase();
    const productPreorderDates = {};
    const productTags = productBlock.dataset.productTags;

    if (productTags) {
      try {
        const tags = JSON.parse(productTags);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        tags.forEach(tag => {
          const lowerTag = tag.toLowerCase();

          if (lowerTag.includes('order-tag:') && lowerTag.includes(':preorder-date:')) {
            const parts = lowerTag.split(':');
            if (parts.length >= 4 && parts[2] === 'preorder-date') {
              const sku = parts[1].toLowerCase();
              const dateString = parts[3];
              const dateParts = dateString.split('-');

              if (dateParts.length === 3) {
                let day, month, year;

                if (market === 'us') {
                  month = parseInt(dateParts[0], 10);
                  day   = parseInt(dateParts[1], 10);
                } else {
                  day   = parseInt(dateParts[0], 10);
                  month = parseInt(dateParts[1], 10);
                }
                year = parseInt(dateParts[2], 10);

                if (
                    !isNaN(month) &&
                    !isNaN(day) &&
                    !isNaN(year) &&
                    month > 0 && month <= 12 &&
                    day > 0 && day <= 31
                ) {
                  const preorderDate = new Date(year, month - 1, day);
                  preorderDate.setHours(0, 0, 0, 0);

                  if (preorderDate >= today) {
                    productPreorderDates[sku] = dateString;
                  }
                }
              }
            }
          }
        });
      } catch (e) {
        console.error('Error parsing productTags', e);
      }
    }

    if (addButton && addButtonText) {
      let buttonText = 'ADD';

      if (!variantAvailable) {
        buttonText = 'SOLD OUT';
        addButton.setAttribute('disabled', 'disabled');
        addButton.classList.add('disabled');
      } else {
        const hasPreorderDateForVariant = productPreorderDates[variantSku];

        if (isPreorder || (hasPreorderDateForVariant && variantInventoryQty !== null && variantInventoryQty <= 0) || (variantInventoryQty !== null && variantInventoryQty <= 0 && variantInventoryPolicy === 'continue' && hasPreorderTag)) {
          buttonText = 'PRE-ORDER';
          addButton.removeAttribute('disabled');
          addButton.classList.remove('disabled');
        } else {
          buttonText = 'ADD';
          addButton.removeAttribute('disabled');
          addButton.classList.remove('disabled');
        }
      }

      addButtonText.textContent = buttonText;

      const existingPreorderInput = form.querySelector('input[name="properties[preorder_date]"]');
      if (buttonText === 'PRE-ORDER') {
        const preorderDateString = productPreorderDates[variantSku] || productPreorderDates['*'] || null;
        const preorderValue = preorderDateString || 'This item is on pre-order.';

        if (!existingPreorderInput) {
          const preorderInput = document.createElement('input');
          preorderInput.type = 'hidden';
          preorderInput.name = 'properties[preorder_date]';
          preorderInput.value = preorderValue;
          form.appendChild(preorderInput);
        } else {
          existingPreorderInput.value = preorderValue;
        }
      } else if (existingPreorderInput) {
        existingPreorderInput.remove();
      }
    }

    productBlock.querySelectorAll('.swatch__button--product').forEach(function(btn) {
      btn.classList.remove('active');
    });
    swatch.classList.add('active');

        let productImageContainer = productBlock.querySelector('.product__media');

        if (productImageContainer && variantImg) {
          let backgroundImageDiv = productImageContainer.querySelector('.background-size-cover');

          if (backgroundImageDiv) {
            backgroundImageDiv.setAttribute('data-bgset', variantImg);
            backgroundImageDiv.style.backgroundImage = "url('" + variantImg + "')";
            if (typeof lazySizes !== 'undefined') {
              lazySizes.loader.unveil(backgroundImageDiv);
            }
          } else {
            productImageContainer.style.backgroundImage = "url('" + variantImg + "')";
          }
        }

        productBlock.querySelectorAll('.show-variant').forEach(function(el) {
          if (el.dataset.variant * 1 === variantId) {
            el.classList.remove('hidden');
            el.style.display = '';
          } else {
            el.classList.add('hidden');
            el.style.display = 'none';
          }
        });

        let formInputs = productBlock.querySelectorAll('.product-upsell-item__form input[data-variant]');
        formInputs.forEach(function(input) {
          if (input.dataset.variant * 1 === variantId) {
            input.classList.remove('hidden');
            input.style.display = '';
            input.name = 'id';
            input.removeAttribute('style');
          } else {
            input.classList.add('hidden');
            input.style.display = 'none';
            input.removeAttribute('name');
          }
        });

        const productHandle = productBlock.dataset.productHandle;
        const productLinks = productBlock.querySelectorAll('[data-variant-link]');
        productLinks.forEach(function(link) {
          link.href = `/products/${productHandle}?variant=${variantId}`;
        });

        let allIdInputs = productBlock.querySelectorAll('.product-upsell-item__form input[name="id"]');
        if (allIdInputs.length > 1) {
          allIdInputs.forEach(function(input, index) {
            if (index > 0) {
              input.removeAttribute('name');
            }
          });
        }
  }

  function initUpsellSwatches() {
    const pairProductsHolder = document.querySelector('[data-pair-products-holder]');

    if (!pairProductsHolder) {
      return;
    }

    if (pairProductsHolder.dataset.upsellDelegationInitialized === 'true') {
      return;
    }

    pairProductsHolder.dataset.upsellDelegationInitialized = 'true';

    pairProductsHolder.addEventListener('click', function(e) {
        const swatch = e.target.closest('.swatch__button--product');
        const swatchLink = e.target.closest('.swatch__link');
        const moreColors = e.target.closest('.more-upcolors');

        if (moreColors) {
          e.preventDefault();

          const productBlock = moreColors.closest('.product-upsell-item');

          if (!productBlock) return;

          const swatchContainer =
            productBlock.querySelector('.product-upsell-item__swatch');

          if (!swatchContainer) return;

          swatchContainer.classList.toggle('openswth');

          if (swatchContainer.classList.contains('openswth')) {
            moreColors.textContent = '✕ Close';
            moreColors.classList.add('is-open');
          } else {
            const count = moreColors.dataset.count || '';
            moreColors.textContent = `+ ${count} Colours`;
            moreColors.classList.remove('is-open');
          }

          return;
        }

        if (swatch) {
          handleSwatchClick(e);
        } else if (swatchLink) {
          e.preventDefault();
          e.stopPropagation();

          const swatchButton = swatchLink.closest('.swatch__button--product');

          if (swatchButton) {
            const syntheticEvent = {
              target: swatchButton,
              preventDefault: function() {},
              stopPropagation: function() {}
            };

            handleSwatchClick(syntheticEvent);
          }
        }
      });
  }

  function observeUpsellContainer() {
    const observer = new MutationObserver(function(mutations) {
      const pairProductsHolder = document.querySelector('[data-pair-products-holder]');
      if (pairProductsHolder && pairProductsHolder.dataset.upsellDelegationInitialized !== 'true') {
        initUpsellSwatches();
        if (typeof swatchInit === 'function') {
          swatchInit();
        }
      }
    });

    const pairProductsHolder = document.querySelector('[data-pair-products-holder]');

    if (pairProductsHolder) {
      observer.observe(pairProductsHolder, {
        childList: true,
        subtree: true
      });
    }

    setTimeout(function() {
      initUpsellSwatches();
    }, 100);
  }

  document.addEventListener('theme:cart:loaded', function() {
    setTimeout(function() {
      initUpsellSwatches();
      observeUpsellContainer();
    }, 300);
  });

  document.addEventListener('theme:cart:open', function() {
    setTimeout(function() {
      initUpsellSwatches();
      observeUpsellContainer();
    }, 400);
  });

  document.addEventListener('theme:cart:added', function() {
    setTimeout(function() {
      initUpsellSwatches();
    }, 500);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {
        initUpsellSwatches();
        observeUpsellContainer();
      }, 1000);
    });
  } else {
    setTimeout(function() {
      initUpsellSwatches();
      observeUpsellContainer();
    }, 1000);
  }

  document.addEventListener('init_switches', function() {
    setTimeout(initUpsellSwatches, 200);
  });

  window.initUpsellSwatches = initUpsellSwatches;
})();

/********************************
 * Cart Upsell Recommendations via Shopify API
 *******************************/
(function() {
  const market = document.body && document.body.getAttribute('data-market');

  function fetchRecommendationsForProduct(productId, cartProductIds, allRecommendationHandles, intent = 'complementary') {
    const baseUrl = window.Shopify?.routes?.root || '';
    const url = `${baseUrl}recommendations/products.json?product_id=${productId}&limit=10&intent=${intent}`;

    return fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to fetch recommendations: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {

        if (data.products && Array.isArray(data.products) && data.products.length > 0) {

          const filtered = data.products
            .filter(product => {
              if (cartProductIds.has(product.id)) {
                return false;
              }
              if (!product.available) {
                return false;
              }
              if (allRecommendationHandles.has(product.handle)) {
                return false;
              }
              if (product.tags && Array.isArray(product.tags) && product.tags.includes('upsell-hidden')) {
                return false;
              }
              allRecommendationHandles.add(product.handle);
              return true;
            })
            .map(product => product.handle);

          return filtered;
        }
        return [];
      })
      .catch(error => {
        console.error(`[UPSELL] Error fetching recommendations for product ${productId} (${intent}):`, error);
        return [];
      });
  }

  let recommendationRequestId = 0;

  function getCartRecommendations() {
    const requestId = ++recommendationRequestId;
    const scrollContainer = document.querySelector('.product-upsell-scroll');
    const drawerUpsell = document.querySelector('.drawer-upsell');

    const existingUpsellItems = document.querySelectorAll('[data-pair-products] .product-upsell-item').length;

    if (scrollContainer && existingUpsellItems === 0) {
      scrollContainer.classList.add('loading');
    }

    if (drawerUpsell) {
      drawerUpsell.style.display = '';
    }

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {

        if (!cart.items || cart.items.length === 0) {
          clearUpsellContainer();
          return;
        }

        const cartProductIds = new Set(cart.items.map(item => item.product_id));
        const allRecommendationHandles = new Set();
        const currencySymbol = cart.currency_symbol || '$';

        const recommendationPromises = cart.items.map(item => {
          return fetchRecommendationsForProduct(item.product_id, cartProductIds, allRecommendationHandles, 'complementary')
            .then(complementaryResults => {
              if (complementaryResults && complementaryResults.length > 0) {
                return complementaryResults;
              }
              return fetchRecommendationsForProduct(item.product_id, cartProductIds, allRecommendationHandles, 'related');
            });
        });

        Promise.all(recommendationPromises)
          .then(results => {
            if (requestId !== recommendationRequestId) return;
            const uniqueHandles = Array.from(new Set(results.flat()));

const filteredHandles = uniqueHandles.filter(
  handle => handle !== 'free-returns-on-your-order'
);

const limitedHandles = filteredHandles.slice(0, 4);

            if (limitedHandles.length > 0) {
              updateUpsellViaSection(limitedHandles, currencySymbol);
            } else {
              clearUpsellContainer();
            }
          })
          .catch(error => clearUpsellContainer());
      })
      .catch(error => {
        console.error('[UPSELL] Error fetching cart:', error);
      });
  }

  function updateUpsellViaSection(handles, currencySymbol) {
    if (!handles || handles.length === 0) {
      clearUpsellContainer();
      return;
    }

    const productPromises = handles.map(handle => {
      return fetch(`/products/${handle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Product not found: ${handle}`);
          }
          return response.json();
        })
        .then(product => {
          return product;
        })
        .catch(error => {
          console.error('[UPSELL] Error fetching product', handle, error);
          return null;
        });
    });

    Promise.all(productPromises)
      .then(products => {
        const validProducts = products.filter(p => {
          if (p === null || !p.available) {
            return false;
          }
          if (p.tags && Array.isArray(p.tags) && p.tags.includes('upsell-hidden')) {
            return false;
          }
          return true;
        })

        if (validProducts.length === 0) {
          clearUpsellContainer();
          return;
        }

        const productsHTML = validProducts.map(product => {
          const currentVariant = product.variants[0];
          const price = (currentVariant.price / 100).toFixed(2);
          const comparePrice = currentVariant.compare_at_price ? (currentVariant.compare_at_price / 100).toFixed(2) : null;
          const image = product.featured_image || (product.images && product.images[0]);

          const hiddenVariants = new Set();
          const hasPreorderTag = product.tags && Array.isArray(product.tags) && product.tags.includes('_preorder');
          const preorderDates = {};

          if (product.tags && Array.isArray(product.tags)) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            product.tags.forEach(tag => {
              const lowerTag = tag.toLowerCase();
              if (lowerTag.includes('variant-hidden:')) {
                const sku = lowerTag.replace('variant-hidden:', '').toLowerCase().trim();
                hiddenVariants.add(sku);
              }

              if (lowerTag.includes('order-tag:') && lowerTag.includes(':preorder-date:')) {
                const parts = lowerTag.split(':');

                if (parts.length >= 4 && parts[2] === 'preorder-date') {
                  const sku = parts[1].toLowerCase();
                  const dateString = parts[3];

                  const dateParts = dateString.split('-');
                  if (dateParts.length === 3) {
                    let day, month, year;

                    if (market === 'us') {
                      month = parseInt(dateParts[0], 10);
                      day   = parseInt(dateParts[1], 10);
                    } else {
                      day   = parseInt(dateParts[0], 10);
                      month = parseInt(dateParts[1], 10);
                    }
                    year = parseInt(dateParts[2], 10);

                    if (
                        !isNaN(month) &&
                        !isNaN(day) &&
                        !isNaN(year) &&
                        month > 0 && month <= 12 &&
                        day > 0 && day <= 31
                    ) {
                      const preorderDate = new Date(year, month - 1, day);
                      preorderDate.setHours(0, 0, 0, 0);

                      if (preorderDate > today) {
                        preorderDates[sku] = dateString;
                      }
                    }
                  }
                }
              }
            });
          }

          function getButtonText(variant) {
            if (!variant.available) {
              return 'SOLD OUT';
            }

            const variantSku = (variant.sku || '').toLowerCase();
            const hasPreorderDate = preorderDates[variantSku] || preorderDates['*'];
            const inventoryQty = variant.inventory_quantity !== undefined && variant.inventory_quantity !== null ? variant.inventory_quantity : null;
            const inventoryPolicy = variant.inventory_policy || 'deny';

            if (hasPreorderDate) {
              return 'PRE-ORDER';
            }

            if (inventoryQty !== null && inventoryQty <= 0 && (hasPreorderTag || inventoryPolicy === 'continue')) {
              return 'PRE-ORDER';
            }

            return 'ADD';
          }

          const visibleVariants = product.variants.filter(variant => {
            const variantSku = (variant.sku || '').toLowerCase().trim();
            return !hiddenVariants.has(variantSku);
          });

          if (visibleVariants.length === 0) {
            return '';
          }

          function isVariantPreorder(variant) {
            const variantSku = (variant.sku || '').toLowerCase();
            const hasPreorderDate = preorderDates[variantSku] || preorderDates['*'];
            const inventoryQty = variant.inventory_quantity !== undefined && variant.inventory_quantity !== null ? variant.inventory_quantity : null;
            const inventoryPolicy = variant.inventory_policy || 'deny';

            if (hasPreorderDate) {
              return true;
            }

            if (inventoryQty !== null && inventoryQty <= 0 && (hasPreorderTag || inventoryPolicy === 'continue')) {
              return true;
            }

            return false;
          }

          let firstVisibleVariant = visibleVariants[0];

          const firstAvailableNotPreorder = visibleVariants.find(v => v.available && !isVariantPreorder(v));
          const firstPreorderVariant = visibleVariants.find(v => v.available && isVariantPreorder(v));

          if (firstAvailableNotPreorder) {
            firstVisibleVariant = firstAvailableNotPreorder;
          } else if (firstPreorderVariant) {
            firstVisibleVariant = firstPreorderVariant;
          }
          const currentPrice = (firstVisibleVariant.price / 100).toFixed(2).replace(/\.00$/, '');
          const currentComparePrice = firstVisibleVariant.compare_at_price
            ? (firstVisibleVariant.compare_at_price / 100).toFixed(2).replace(/\.00$/, '')
            : null;
          const currentImage = firstVisibleVariant.featured_image?.src || image;

          const hasColors = product.options && product.options.some(opt =>
            opt.name.toLowerCase() === 'color' || opt.name.toLowerCase() === 'colour'
          );

          let swatchesHTML = '';
          if (hasColors) {
            const colorOption = product.options.find(opt =>
              opt.name.toLowerCase() === 'color' || opt.name.toLowerCase() === 'colour'
            );

            if (colorOption) {
              const colorLabel = colorOption.name;
              let activeSwatchHTML = '';
              let inactiveSwatchesHTML = '';

              colorOption.values.forEach((option, index) => {
                const variant = visibleVariants.find(v =>
                  v.option1 === option || v.option2 === option || v.option3 === option
                );

                if (variant) {
                  const filesBaseUrl = window.themeFilesBaseUrl || 'https://cdn.shopify.com/s/files/1/0640/5535/9681/files/';
                  const variantImage = variant.featured_image?.src || currentImage;
                  const variantImageId = variant.featured_image?.id || '';
                  const colorFileName = option.toLowerCase().replace(/\s+/g, '_') + '.png';
                  const isActive = variant.id === firstVisibleVariant.id;
                  const soldOutClass = !variant.available ? ' sold-out' : '';
                  const optionHandle = option.toLowerCase().replace(/\s+/g, '-');

                  const variantInventoryQty = variant.inventory_quantity !== undefined && variant.inventory_quantity !== null ? variant.inventory_quantity : (variant.inventory_management ? 0 : null);
                  const variantInventoryPolicy = variant.inventory_policy || 'deny';
                  const variantSku = (variant.sku || '').toLowerCase();
                  const hasPreorderDate = preorderDates[variantSku] || preorderDates['*'];
                  const isPreorder = variant.available && (
                    (variantInventoryQty !== null && variantInventoryQty <= 0 && (hasPreorderTag || variantInventoryPolicy === 'continue')) ||
                    hasPreorderDate
                  );

                  const swatchHTML = `
                    <div class="swatch__button swatch__button--product${isActive ? ' active' : ''}${soldOutClass}" 
                         data-swatch-button
                         data-value="${option}"
                         data-variant-available="${variant.available}"
                         data-variant-inventory-qty="${variantInventoryQty}"
                         data-variant-inventory-policy="${variantInventoryPolicy}"
                         data-is-preorder="${isPreorder}">
                      <div id="${product.id}-${variant.id}-${optionHandle}"
                           class="swatch__label"
                           data-name="${variant.title}"
                           data-swatch="${option}"
                           data-swatch-variant="${variant.id}"
                           data-swatch-variants="${variant.sku || ''}"
                           data-swatch-image="${variantImage}"
                           data-swatch-image-id="${variantImageId}"
                           data-tooltip="${option}"
                           data-variant-available="${variant.available}"
                           data-variant-inventory-qty="${variantInventoryQty}"
                           data-variant-inventory-policy="${variantInventoryPolicy}"
                           data-is-preorder="${isPreorder}"
                           style="background-image: url('${filesBaseUrl}${colorFileName}');">
                      </div>
                      <a href="/products/${product.handle}?variant=${variant.id}"
                         data-swatch-variant="${variant.id}"
                         class="swatch__link">${variant.title}</a>
                    </div>
                  `;

                  if (isActive) {
                    activeSwatchHTML = swatchHTML;
                  } else {
                    inactiveSwatchesHTML += swatchHTML;
                  }
                }
              });

              const selectedColorValue = colorOption.values.find(v =>
                  firstVisibleVariant.option1 === v ||
                  firstVisibleVariant.option2 === v ||
                  firstVisibleVariant.option3 === v
              ) || firstVisibleVariant.option1 || firstVisibleVariant.option2 || firstVisibleVariant.option3 || '';

              const moreColors = colorOption.values.length - 1;

              swatchesHTML = `
                <div class="product-upsell-item__selected-color" data-selected-color-text>
                  <span data-selected-color-value>${selectedColorValue}</span>

                  ${
                    moreColors > 0
                      ? `
                       <span class="more-upcolors"
                        data-count="${moreColors}">
                    + ${moreColors}
                    ${moreColors === 1 ? 'Colour' : 'Colours'}
                  </span>
                      `
                      : ''
                  }
                </div>

                <product-grid-item-swatch
                  class="product-upsell-item__swatch"
                  data-swatch-handle="${product.handle}"
                  data-swatch-label="${colorLabel}"
                  data-tooltip="${colorLabel}">
                  ${activeSwatchHTML}
                  ${inactiveSwatchesHTML}
                </product-grid-item-swatch>
              `;
            }
          }

          let variantInputsHTML = '';
          if (hasColors) {
            visibleVariants.forEach((variant) => {
              const isActive = variant.id === firstVisibleVariant.id;
              const hiddenClass = !isActive ? 'hidden' : '';
              const displayStyle = !isActive ? 'style="display: none;"' : '';
              variantInputsHTML += `
                <input type="hidden"  name="${isActive ? 'id' : ''}" 
                  value="${variant.id}" 
                  class="show-variant ${hiddenClass}" 
                  data-variant="${variant.id}" 
                  ${displayStyle}>
              `;
            });
          } else {
            variantInputsHTML = `<input type="hidden" name="id" value="${firstVisibleVariant.id}">`;
          }

          let pricesHTML = '';
          if (hasColors) {
            visibleVariants.forEach((variant) => {
              const isActive = variant.id === firstVisibleVariant.id;
              const hiddenClass = !isActive ? ' hidden' : '';
              const displayStyle = !isActive ? ' style="display: none;"' : '';
              const vPrice = (variant.price / 100).toFixed(2).replace(/\.00$/, '');
              const vComparePrice = variant.compare_at_price
              ? (variant.compare_at_price / 100).toFixed(2).replace(/\.00$/, '')
              : null;
              const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

              if (onSale) {
                pricesHTML += `
                  <div class="product-upsell-item__price price product-grid-item__price show-variant${hiddenClass}"
                       data-variant="${variant.id}"${displayStyle}>
                    <span class="product-upsell-item__price__new">${currencySymbol}${vPrice}</span>
                    <s>${currencySymbol}${vComparePrice}</s>
                  </div>
                `;
              } else {
                pricesHTML += `
                  <div class="product-upsell-item__price price product-grid-item__price show-variant${hiddenClass}"
                       data-variant="${variant.id}"${displayStyle}>
                    ${currencySymbol}${vPrice}
                  </div>
                `;
              }
            });
          } else {
            const onSale = firstVisibleVariant.compare_at_price && firstVisibleVariant.compare_at_price > firstVisibleVariant.price;
            if (onSale) {
              pricesHTML = `
                <div class="product-upsell-item__price product-grid-item__price">
                  <span class="product-upsell-item__price__new">${currencySymbol}${currentPrice}</span>
                  <s>${currencySymbol}${currentComparePrice}</s>
                </div>
              `;
            } else {
              pricesHTML = `<div class="product-upsell-item__price product-grid-item__price">${currencySymbol}${currentPrice}</div>`;
            }
          }

          const productTagsJson = JSON.stringify(product.tags || []).replace(/'/g, "&#39;");

          return `
<div class="product-upsell-item product-grid-item grid__item"
     data-product-id="${product.id}"
     data-product-handle="${product.handle}"
     data-upsell-holder
     data-product-tags='${productTagsJson}'
     ${hasPreorderTag ? 'data-product-preorder-tag="true"' : ''}>

  <div class="product-grid-item__inner">

    <div class="product-grid-item__image" data-product-media-container>

      <div class="product__media__outer">
        <div class="product__media__inner">

          <div class="product__media__container">

            <a href="/products/${product.handle}${firstVisibleVariant.id !== product.variants[0].id ? '?variant=' + firstVisibleVariant.id : ''}"
               class="product__media__holder"
               data-variant-link>

              <div class="product__media__image lazy-image"
                   style="background-image:url('${currentImage}')">

                <div class="product__media background-size-cover lazyloaded"
                     data-bgset="${currentImage}"
                     style="background-image:url('${currentImage}')">
                </div>

              </div>

            </a>
            <div class="product-grid-item__quick-buy onlyiconadd">
            <form method="post" action="/cart/add" 
             accept-charset="UTF-8" class="quick__form product-upsell-item__form" 
             enctype="multipart/form-data" data-product-form="" data-quickbuy-form="">
                ${variantInputsHTML}

                <input type="hidden" name="quantity" value="1">

                ${(() => {
                  const variantSku = (firstVisibleVariant.sku || '').toLowerCase();
                  const preorderDateString =
                    preorderDates[variantSku] || preorderDates['*'] || null;

                  const shouldShowPreorder =
                    (firstVisibleVariant.inventory_quantity || 0) <= 0 &&
                    (
                      hasPreorderTag ||
                      firstVisibleVariant.inventory_policy === 'continue' ||
                      preorderDateString
                    );

                  if (shouldShowPreorder) {
                    const preorderValue =
                      preorderDateString || 'This item is on pre-order.';

                    return `
                      <input
                        type="hidden"
                        name="properties[preorder_date]"
                        value="${preorderValue.replace(/"/g, '&quot;')}">
                    `;
                  }

                  return '';
                })()}

                <button
                  type="submit"
                  class="btn--quick addcartbtn square"
                   data-add-to-cart
                  data-cart-drawer-toggle
                  ${!firstVisibleVariant.available ? 'disabled' : ''}>
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-plus" viewBox="0 0 192 192"><path d="M30 96h132M96 30v132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </span>

                </button>

              </form>
              </div>
          </div>

        </div>
      </div>

    </div>

    <div class="product-grid-item__info product-grid-item__info--inline">

      <div class="product-grid-item__info-content">

        <span class="infotitle">
          <a class="product-grid-item__title"
             href="/products/${product.handle}${firstVisibleVariant.id !== product.variants[0].id ? '?variant=' + firstVisibleVariant.id : ''}"
             data-variant-link>
            ${product.title}
          </a>
        </span>

        <span class="product-grid-item__info-separator"></span>

        ${pricesHTML}

      </div>

      ${swatchesHTML}

    </div>

  </div>

  <div
    data-cart-errors-container
    class="product-upsell-item__errors">
  </div>

</div>
`;
        }).filter(html => html !== '').join('');

        const pairProducts = document.querySelector('[data-pair-products]');
        const scrollContainer = document.querySelector('.product-upsell-scroll');

        if (pairProducts && productsHTML) {
          const drawerUpsell = pairProducts.closest('.drawer-upsell') || document.querySelector('.drawer-upsell');
          if (drawerUpsell) {
            drawerUpsell.style.display = '';
          }

          pairProducts.innerHTML = productsHTML;

          const upsellGrid = pairProducts;
          if (upsellGrid && window.matchMedia('(max-width: 991px)').matches) {
            //upsellGrid.setAttribute('data-scroll-lock-scrollable', '');

            const scrollContainer = upsellGrid.closest('.product-upsell-scroll');
            if (scrollContainer) {
             // scrollContainer.setAttribute('data-scroll-lock-scrollable', '');
            }

            let touchStartX = 0;
            let touchStartY = 0;
            let isScrolling = false;

            document.addEventListener('touchstart', function(e) {
              if (e.target.closest('.product-upsell-grid')) {
                touchStartX = e.touches[0].clientX;
                touchStartY = e.touches[0].clientY;
                isScrolling = false;
              }
            }, { passive: true, capture: true });

            document.addEventListener('touchmove', function(e) {
              const target = e.target.closest('.product-upsell-grid');
              if (!target || !touchStartX || !touchStartY) return;

              const touchX = e.touches[0].clientX;
              const touchY = e.touches[0].clientY;
              const deltaX = touchX - touchStartX;
              const deltaY = touchY - touchStartY;

              if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 5) {
                isScrolling = true;

                const scrollLeft = target.scrollLeft;
                const scrollWidth = target.scrollWidth;
                const clientWidth = target.clientWidth;
                const maxScroll = scrollWidth - clientWidth;

                const atLeftEdge = scrollLeft <= 0;
                const atRightEdge = scrollLeft >= maxScroll;

                if ((!atLeftEdge && !atRightEdge) ||
                    (atLeftEdge && deltaX < 0) ||
                    (atRightEdge && deltaX > 0)) {
                  e.stopPropagation();
                  return;
                }
              }
            }, { passive: true, capture: true });

            document.addEventListener('touchend', function(e) {
              if (e.target.closest('.product-upsell-grid')) {
                touchStartX = 0;
                touchStartY = 0;
               isScrolling = true;
              }
            }, { passive: true, capture: true });

            document.addEventListener('touchcancel', function(e) {
              if (e.target.closest('.product-upsell-grid')) {
                touchStartX = 0;
                touchStartY = 0;
                isScrolling = true;
              }
            }, { passive: true, capture: true });

            upsellGrid.addEventListener('wheel', function(e) {
              const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY) || e.deltaX !== 0;

              if (isHorizontal) {
                const scrollLeft = upsellGrid.scrollLeft;
                const scrollWidth = upsellGrid.scrollWidth;
                const clientWidth = upsellGrid.clientWidth;
                const maxScroll = scrollWidth - clientWidth;

                const atLeftEdge = scrollLeft <= 0;
                const atRightEdge = scrollLeft >= maxScroll;

                if ((!atLeftEdge && !atRightEdge) ||
                    (atLeftEdge && e.deltaX < 0) ||
                    (atRightEdge && e.deltaX > 0)) {
                  e.preventDefault();
                  upsellGrid.scrollLeft += e.deltaX;
                }
              }
            }, { passive: false });
          }

          setTimeout(function() {
            if (typeof window.initUpsellSwatches === 'function') {
              window.initUpsellSwatches();
            } else if (typeof initUpsellSwatches === 'function') {
              initUpsellSwatches();
            }
            if (typeof swatchInit === 'function') {
              swatchInit();
            }

            const scrollContainer = document.querySelector('.product-upsell-scroll');
            if (scrollContainer) {
              scrollContainer.classList.remove('loading');
            }
          }, 100);
        } else {
          clearUpsellContainer();
        }
      })
      .catch(error => {
        console.error('[UPSELL] Error rendering products:', error);
        const scrollContainer = document.querySelector('.product-upsell-scroll');
        if (scrollContainer) {
          scrollContainer.classList.remove('loading');
        }
        clearUpsellContainer();
      });
  }

  function clearUpsellContainer() {
    const pairProductsHolder = document.querySelector('[data-pair-products-holder]');
    const scrollContainer = document.querySelector('.product-upsell-scroll');

    if (pairProductsHolder) {
      const drawerUpsell = pairProductsHolder.querySelector('.drawer-upsell');

      if (drawerUpsell) {
        const pairProducts = drawerUpsell.querySelector('[data-pair-products]');
        if (pairProducts) {
          pairProducts.innerHTML = '';
        }
        drawerUpsell.style.display = 'none';
      } else {
        pairProductsHolder.innerHTML = '';
      }
    }

    if (scrollContainer) {
      scrollContainer.classList.remove('loading');
    }
  }

  let observedUpsellContainer = null;
  let upsellObserver = null;

  function observeUpsellChanges() {
    const pairProducts = document.querySelector('[data-pair-products]');
    if (!pairProducts || pairProducts === observedUpsellContainer) return;

    if (upsellObserver) {
      upsellObserver.disconnect();
    }

    observedUpsellContainer = pairProducts;
    upsellObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const currentContent = pairProducts.innerHTML.trim();
          const scrollContainer = document.querySelector('.product-upsell-scroll');
          const drawerUpsell = document.querySelector('.drawer-upsell');

          if (currentContent === '' && scrollContainer && !scrollContainer.classList.contains('loading')) {
            scrollContainer.classList.add('loading');
            if (drawerUpsell) {
              drawerUpsell.style.display = '';
            }
          }
        }
      });
    });

    upsellObserver.observe(pairProducts, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  let recommendationRefreshTimer;

  function scheduleCartRecommendations() {
    clearTimeout(recommendationRefreshTimer);
    recommendationRefreshTimer = setTimeout(getCartRecommendations, 50);
  }

  document.addEventListener('theme:cart:loaded', function() {
    observeUpsellChanges();
  });

  document.addEventListener('theme:cart:added', function() {
    observeUpsellChanges();
    scheduleCartRecommendations();
  });

  document.addEventListener('theme:cart:open', function() {
    observeUpsellChanges();

    const pairProducts = document.querySelector('[data-pair-products]');
    if (!pairProducts || pairProducts.children.length === 0) {
      scheduleCartRecommendations();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(observeUpsellChanges, 1000);
    });
  } else {
    setTimeout(observeUpsellChanges, 1000);
  }
})();

document.addEventListener("DOMContentLoaded", function () {
				const toggles = document.querySelectorAll(".submenu-toggle");

				toggles.forEach(toggle => {
					toggle.addEventListener("click", function (e) {
					e.preventDefault();

					const parent = this.closest(".dropdown__item");
					const submenu = parent.querySelector(".dropdown__submenu");

					// Close other open submenus (optional)
					document.querySelectorAll(".dropdown__item.active").forEach(item => {
						if (item !== parent) {
						item.classList.remove("active");
						const sub = item.querySelector(".dropdown__submenu");
						if (sub) sub.style.maxHeight = null;
						}
					});

					// Toggle current submenu
					parent.classList.toggle("active");

					if (parent.classList.contains("active")) {
						submenu.style.maxHeight = submenu.scrollHeight + "px";
					} else {
						submenu.style.maxHeight = null;
					}
					});
				});
				});